<script>
import Layout from "@/router/layouts/main";
import { mapState } from "vuex";
import { api } from "@/state/services";

export default {
  locales: {
    pt: {
    },
    es: {
    }
  },
  components: {
    Layout,
  },
  computed: {
    ...mapState({
      account: state => state.account
    }),
  },
  data() {
    return {
      consultas: null,
    };
  },
  methods: {
    getConsultas() {
      this.consultas = null;

      api
        .get('telemedicina/consultas')
        .then((response) => {
          if (response.data.status == 'success') {
            this.consultas = response.data.list;
          }
        })
    },
  },
  mounted() {
    this.getConsultas();
  }
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item"><router-link tag="a" to="/seguros">Seguros</router-link></li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>Assistência Residêncial</h3>
        <p></p>
      </div>
    </div>

    <h5 class="mb-4">Coberturas</h5>

    <div class="card">
      <div class="card-body">
        <div class="border-bottom pt-2 pb-4">
          <h5 class="font-size-15">Chaveiro, eletricista, encanador e vidraceiro (emergencial ou não)</h5>
          <div class="font-size-12">
            R$ 200,00 por evento<br>
            Até 02 acionamentos por ano
          </div>
        </div>
        <div class="border-bottom py-4">
          <h5 class="font-size-15">Limpeza do imóvel em caso de sinistro que dificulte sua utilização</h5>
          <div class="font-size-12">
            R$ 150,00 por evento<br>
            Até 01 acionamento por ano
          </div>
        </div>
        <div class="border-bottom py-4">
          <h5 class="font-size-15">Vigilante</h5>
          <div class="font-size-12">
            R$ 550,00 por evento<br>
            Até 01 acionamento por ano
          </div>
        </div>
        <div class="border-bottom py-4">
          <h5 class="font-size-15">Cobertura provisória de telhados</h5>
          <div class="font-size-12">
            R$ 400,00 por evento<br>
            Até 01 acionamento por ano
          </div>
        </div>
        <div class="border-bottom py-4">
          <h5 class="font-size-15">Consulta orçamentária para manutenção geral do imóvel</h5>
          <div class="font-size-12">
            Sem limite de acionamentos por evento<br>
            Até 02 acionamento por ano
          </div>
        </div>
        <div class="border-bottom py-4">
          <h5 class="font-size-15">Desentupimento (emergencial ou não)</h5>
          <div class="font-size-12">
            R$ 400,00 por evento<br>
            Até 01 acionamento por ano
          </div>
        </div>
        <div class="border-bottom py-4">
          <h5 class="font-size-15">Conserto de eletrodomésticos (linha branca)</h5>
          <div class="font-size-12">
            Até R$ 300,00 por aparelhos com até 05 anos de uso<br>
            Até 01 acionamento por ano
          </div>
        </div>
        <div class="border-bottom py-4">
          <h5 class="font-size-15">Limpeza de ar-condicionado</h5>
          <div class="font-size-12">
            Até R$ 250,00<br>
            Até 01 acionamento por ano
          </div>
        </div>
        <div class="border-bottom py-4">
          <h5 class="font-size-15">Instalação de trincos, fechaduras, antiarrombantes e barras de segurança</h5>
          <div class="font-size-12">
            R$ 200,00 por evento<br>
            Até 02 acionamentos por ano
          </div>
        </div>
        <div class="border-bottom py-4">
          <h5 class="font-size-15">Fixação de acessórios (varal, prateleiras, suporte TV etc.)</h5>
          <div class="font-size-12">
            R$ 250,00 por evento<br>
            Até 02 acionamentos por ano
          </div>
        </div>
        <div class="border-bottom py-4">
          <h5 class="font-size-15">Desinsetização, desratização e descupinização</h5>
          <div class="font-size-12">
            R$ 600,00<br>
            Avaliação técnica: limitado ao valor de R$ 50,00
          </div>
        </div>
        <div class="pt-2">
          <a href="https://wa.me/552135147535" target="_blank" class="btn btn-outline-default btn-block mt-3">
            Acionar Assistência
          </a>
        </div>
      </div>
    </div>
  </Layout>
</template>